import { EmailEditor } from "@consultants/consultant-profile-new/email-editor/email-editor";
import { UseFormReturn } from "react-hook-form";
import { ThirdFormValues } from "../utils/form-values";

type Props = {
  form: UseFormReturn<ThirdFormValues, any, ThirdFormValues>;
  onSubmit: () => void;
};

export const ThirdStep = ({ form, onSubmit }: Props) => {
  const initialEmailBody = `
    För att komma till presentationen: <a href='CONSULTANT_PRESENTATION_URL'>klicka här</a><br>
    (Länken är giltig i 30 dagar. Länken fungerar även om du behöver vidarebefordra mailet till annan mottagare.
    Länken ovan ger bästa möjliga överblick av dokumenten i presentationen).
    `;

  const fullPresentation = `
    <br><br>
    För att ladda ner presentation: <a href='FULL_PRESENTATION_URL'>klicka här</a><br>
    (Med anledning av GDPR önskar vi att ni främst laddar ner presentationen om länken till överblicken ovan inte fungerar).
    `;

  return (
    <EmailEditor
      form={form}
      editorInitialValue={initialEmailBody + fullPresentation}
      isCustomerSearch={true}
    />
  );
};
